import { TeamPlayersNumber } from 'shared/types/team-players-number';
import { SymbolicTeamFormPlayer } from 'modules/championship/domain/interfaces/symbolic-team-form-player';

export const buildEmptyPlayers = (playersNumber: TeamPlayersNumber): SymbolicTeamFormPlayer[] => {
  const players: SymbolicTeamFormPlayer[] = [];

  for (let i = 1; i < playersNumber; i++) {
    players.push({ rank: i });
  }

  return players;
};
